import { Form, Button } from "antd";
import OtpInput from "react-otp-input";
import { FaArrowRight } from "react-icons/fa6";

const RegisterStepOtp = ({
  otp,
  setOtp,
  timeLeft,
  onResend,
  onVerify,
  onEditPhone,
}) => (
  <>
    <Form layout="vertical" onFinish={onVerify}>
      <Form.Item>
        <label className="label" className="mb-3 block text-primary-text text-base" htmlFor="otp">ও টি পি দিন</label>
        {/* <OtpInput
          id="otp"
          value={otp}
          onChange={setOtp}
          numInputs={4}
          renderInput={(props) => <input {...props} />}
          inputStyle={{
            width: "40px",
            height: "40px",
            fontSize: "16px",
            borderRadius: "8px",
            border: "1px solid #616161",
            textAlign: "center",
            color: '#0091EA',
          }}

          containerStyle={{ justifyContent: "center", gap: "8px" }}
        /> */}

        <OtpInput
          id="otp"
          value={otp}
          onChange={setOtp}
          numInputs={4}
          renderInput={(props) => (
            <input
              {...props}
              inputMode="numeric"
              pattern="[0-9]*"
              type="text"
              onKeyPress={(e) => {
                if (!/[0-9]/.test(e.key)) {
                  e.preventDefault();
                }
              }}
            />
          )}
          inputStyle={{
            width: "40px",
            height: "40px",
            fontSize: "16px",
            borderRadius: "8px",
            border: "1px solid #616161",
            textAlign: "center",
            color: "#0091EA",
          }}
          containerStyle={{ justifyContent: "center", gap: "8px" }}
        />

      </Form.Item>

      <div className="flex justify-between mb-3">
      <div className="text-center !text-paragraph-text text-sm  bg-fill-bright-gray py-1 px-3 rounded-lg">
        {timeLeft > 0 ? (
          <span className="mt-1 block">
            পুনরায় পাঠান {Math.floor(timeLeft / 60)}:
            {String(timeLeft % 60).padStart(2, "0")}
          </span>
        ) : (
          <button type="link" onClick={onResend} className="!text-paragraph-text p-0 mt-1">
            পুনরায় পাঠান
          </button>
        )}
      </div>

      <a
        onClick={onEditPhone}
        className="!text-primary-text py-1 px-3 rounded-lg border border-primary-border block"
      >
        নাম্বার পরিবর্তন
      </a>
      </div>

      <Button
        type="primary"
        htmlType="submit"
        size="large"
        className="login-regictation-submit-btn mb-0"
        disabled={otp.length !== 4}
      >
        পরবর্তী ধাপ <FaArrowRight />
      </Button>
    </Form>
  </>
);

export default RegisterStepOtp;
